// Minimal text diff — common-prefix/suffix scan. No diff library (`diff` is banned,
// CLAUDE.md rule 10). The returned window {start, removed, added} is exactly the
// changed segment, which is what both the history payload and the inline diff renderer
// need.
//
// Parity: backend/domain/diff.ts holds an identical copy (the web app cannot import
// backend source). Keep the two in sync.

export interface ChangedRegion {
  start: number
  removed: string
  added: string
}

/** Smallest single contiguous window that turns `before` into `after`. */
export function computeChangedRegion(before: string, after: string): ChangedRegion {
  if (before === after) return { start: 0, removed: '', added: '' }
  let start = 0
  const min = Math.min(before.length, after.length)
  while (start < min && before[start] === after[start]) start++
  let endBefore = before.length
  let endAfter = after.length
  while (endBefore > start && endAfter > start && before[endBefore - 1] === after[endAfter - 1]) {
    endBefore--
    endAfter--
  }
  return {
    start,
    removed: before.slice(start, endBefore),
    added: after.slice(start, endAfter),
  }
}
